// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"177":"36231643","402":"6b6ec729","454":"956550ce","878":"2b29eaeb"}[chunkId] + ".css";
};